import React from 'react';
import PropTypes from 'prop-types';
import CircleButton from './CircleButton';
import CopyIcon from '../icons/CopyIcon';
import sizes from './sizes';
const CopyButton = ({ disabled, onClick, title, id, className, size }) => {
    return (React.createElement(CircleButton, { id: id, size: size, className: className, color: "green", disabled: disabled, onClick: onClick, title: title },
        React.createElement(CopyIcon, null)));
};
CopyButton.propTypes = {
    id: PropTypes.string,
    size: PropTypes.oneOf(Object.values(sizes)),
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.object,
    ]),
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.string,
};
CopyButton.defaultProps = {
    size: sizes.normal,
    disabled: false,
    title: '',
};
export default CopyButton;
